import CooperationResults from './components/CooperationTools';
import DemandInbox from './pages/DemandInbox';
import OrganizerDiscovery from './pages/OrganizerDiscovery';
import GoogleCallback from './pages/GoogleCallback';
import AdvertisingRequest from './pages/AdvertisingRequest';
import AdvertisingPrivacy from './pages/AdvertisingPrivacy';
import WorkspaceHome from './pages/WorkspaceHome';
import IndividualHome from './pages/IndividualHome';
import VenueIndividualRequests from './pages/VenueIndividualRequests';
import React, { useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from './contexts/ThemeContext';
import { PublicThemePicker, ThemeToaster } from './components/ThemePicker';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';
import { APP_NAME, userHome } from './config/brand';
import OrganizerIdea from './pages/OrganizerIdea';
import VenueIdea from './pages/VenueIdea';
import OrganizerProjectDetail from './pages/OrganizerProjectDetail';
import Login from './pages/Login';
import PasswordRecovery from './pages/PasswordRecovery';
import Register from './pages/Register';
import VenueProfile from './pages/VenueProfile';
import OrganizerProfile from './pages/OrganizerProfile';
import AdminVenues from './pages/AdminVenues';
import AdminMembers from './pages/AdminMembers';
import AdminOrganizers from './pages/AdminOrganizers';
import AdminMatches from './pages/AdminMatches';
import EventRequests from './pages/EventRequests';
import OrganizerSearch from './pages/OrganizerSearch';
import AdminInterests from './pages/AdminInterests';
import AdminVenueInvites from './pages/AdminVenueInvites';
import AdminSettings from './pages/AdminSettings';
import AdminStaff from './pages/AdminStaff';
import StaffHome from './pages/StaffHome';
import AdminReviews from './pages/AdminReviews';
import AdminReports from './pages/AdminReports';
import AdminEventReviews from './pages/AdminEventReviews';
import AdminPool from './pages/AdminPool';
import StaffInviteRegister from './pages/StaffInviteRegister';
import ClaimInvite from './pages/ClaimInvite';
import VenueInviteRegister from './pages/VenueInviteRegister';
import VenueDetail from './pages/VenueDetail';
import ProPage from './pages/ProPage';
import OrganizerAssistant from './pages/OrganizerAssistant';

const RootRedirect = () => {
  const { user, loading, authError, checkAuth, logout } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-[#1E3A8A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-sm text-zinc-500">Yükleniyor…</p>
        </div>
      </div>
    );
  }
  if (authError) return <div role="alert" className="p-8 text-center"><p>{authError}</p><button className="action-primary mt-4" onClick={checkAuth}>Tekrar dene</button></div>;
  if (user && !userHome(user)) return <div role="alert" className="p-8 text-center" data-testid="staff-access-unavailable">
    <p>Personel yetkin şu anda etkin değil. Lütfen ana yöneticiyle iletişime geç.</p>
    <button className="action-primary mt-4" onClick={logout}>Çıkış yap</button></div>;
  return user
    ? <Navigate to={userHome(user)} replace />
    : <Navigate to="/login" replace />;
};

function App() {
  useEffect(() => { document.title = APP_NAME; }, []);
  return (
    <ThemeProvider><div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ThemeToaster /><PublicThemePicker />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/advertising/privacy" element={<AdvertisingPrivacy />} />
            <Route path="/auth/google" element={<GoogleCallback />} />
            <Route path="/forgot-password" element={<PasswordRecovery key="forgot" />} />
            <Route path="/reset-password" element={<PasswordRecovery key="reset" reset />} />
            <Route path="/register" element={<Register />} />
            <Route path="/bireysel/kayit" element={<Register individualOnly />} />
            <Route path="/mekan-davet/:token" element={<VenueInviteRegister />} />
            <Route path="/mekan-davet" element={<VenueInviteRegister />} />
            <Route path="/kart-davet" element={<ClaimInvite />} />
            <Route path="/personel-davet" element={<StaffInviteRegister />} />
            {/* Personel paneli: sunucu her istekte aynı izni ayrıca doğrular. */}
            <Route path="/staff" element={
              <ProtectedRoute requiredPermission="pool.view">
                <Layout><StaffHome /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/individual" element={<ProtectedRoute allowedRoles={['individual']}><IndividualHome /></ProtectedRoute>} />
            <Route path="/dashboard" element={
              <ProtectedRoute allowedRoles={['admin', 'venue']}>
                <Layout><WorkspaceHome /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/venue/individual-requests" element={<ProtectedRoute allowedRoles={['venue']}><Layout><VenueIndividualRequests /></Layout></ProtectedRoute>} />
            <Route path="/venue/cooperation" element={<ProtectedRoute allowedRoles={['venue']}><Layout><CooperationResults /></Layout></ProtectedRoute>} />
            <Route path="/organizer/cooperation" element={<ProtectedRoute allowedRoles={['organizer']}><Layout><CooperationResults /></Layout></ProtectedRoute>} />
            <Route path="/venue/idea" element={<ProtectedRoute allowedRoles={['venue']}><Layout><VenueIdea /></Layout></ProtectedRoute>} />
            <Route path="/venue/discovery" element={<ProtectedRoute allowedRoles={['venue']}><Layout><OrganizerDiscovery /></Layout></ProtectedRoute>} />
            <Route path="/venue/profile" element={
              <ProtectedRoute allowedRoles={['venue']}>
                <Layout><VenueProfile /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/venue/matches" element={
              <ProtectedRoute allowedRoles={['venue']}>
                <Layout><DemandInbox initialTab="legacy" /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/venue/applications" element={
              <ProtectedRoute allowedRoles={['venue']}>
                <Layout><DemandInbox /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/venues/:venueId" element={
              <ProtectedRoute allowedRoles={['organizer', 'admin', 'venue']}>
                <Layout><VenueDetail /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/organizer/profile" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><OrganizerProfile /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/organizer/home" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><WorkspaceHome /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/organizer/projects/:projectId" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><OrganizerProjectDetail /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/organizer/idea" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><OrganizerIdea /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/organizer/search" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><OrganizerSearch /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/organizer/applications" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><DemandInbox /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/organizer/assistant" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><OrganizerAssistant /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/pro" element={
              <ProtectedRoute allowedRoles={['organizer', 'venue', 'admin']}>
                <Layout><ProPage /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/advertising" element={
              <ProtectedRoute allowedRoles={['organizer', 'venue']}>
                <Layout><AdvertisingRequest /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout><AdminMembers /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/venues" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout><AdminVenues /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/organizers" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout><AdminOrganizers /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/matches" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout><AdminMatches /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/interests" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout><AdminInterests /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/venue-invites" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout><AdminVenueInvites /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/pool" element={
              <ProtectedRoute requiredPermission="pool.view">
                <Layout><AdminPool /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/reviews" element={
              <ProtectedRoute requiredPermission="review.dna">
                <Layout><AdminReviews /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/reports" element={
              <ProtectedRoute requiredPermission="reports.review">
                <Layout><AdminReports /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/event-reviews" element={
              <ProtectedRoute requiredPermission="events.verify">
                <Layout><AdminEventReviews /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/staff" element={
              <ProtectedRoute allowedRoles={['admin']} requiredPermission="staff.manage">
                <Layout><AdminStaff /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/settings" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Layout><AdminSettings /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/swipe" element={
              <ProtectedRoute allowedRoles={['venue']}>
                <Layout><OrganizerDiscovery /></Layout>
              </ProtectedRoute>
            } />
            {/* Eski organizer route'ları — geriye uyum için erişilebilir ama nav'dan gizli */}
            <Route path="/organizer/matches" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><DemandInbox initialTab="legacy" /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/organizer/event-requests" element={
              <ProtectedRoute allowedRoles={['organizer']}>
                <Layout><EventRequests /></Layout>
              </ProtectedRoute>
            } />
            <Route path="*" element={<RootRedirect />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div></ThemeProvider>
  );
}

export default App;
